import gql from 'graphql-tag';
import { memberInvitationGQLFields, } from './memberInvitation.fields.js';
export function inviteMembersGQLQuery(fields) {
    return gql `
    mutation InviteMembers($input: InviteMembersInput!) {
      inviteMembers(input: $input) {
        ${memberInvitationGQLFields(fields)}
      }
    }
`;
}
export function memberInvitationValidityGQLQuery(fields) {
    return gql `
    query memberInvitationValidity($token: String!) {
      memberInvitationValidity(token: $token) {
        ${memberInvitationGQLFields(fields)}
      }
    }
  `;
}
export function invitationLinkValidityGQLQuery() {
    return gql `
    query invitationLinkValidity($id: String!) {
      invitationLinkValidity(id: $id) {
        id
        link
      }
    }
  `;
}
export function getMemberInvitationsGQLQuery(fields) {
    return gql `
    query GetMemberInvitations(
      $limit: Int!
      $query: String
      $after: String
      $status: MemberInvitationStatus
      $reverse: Boolean
    ) {
      memberInvitations(
        limit: $limit
        query: $query
        after: $after
        status: $status
        reverse: $reverse
      ) {
        totalCount
        edges {
          node {
            ${memberInvitationGQLFields(fields)}
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `;
}
export function getInvitationLinkGQLQuery() {
    return gql `
    query getInvitationLink {
      memberInvitationLink {
        link
      }
    }
  `;
}
//# sourceMappingURL=invitations.gql.js.map